import React from 'react';
import { createPortal } from 'react-dom';
import thunderIcon from '../../../assets/notify-thunder.svg';
import FooterNav from '../../molecules/footer-nav/footerNav';
import Footer from '../../molecules/footer/footer';
import Header from '../../molecules/header/header';
import UserPointsContext from './contexts/user-points.context';
import usePoints from './hooks/usePoints';
import './layout.scss';

type NotifySystem = {
	container?: any;
	toast?: any;
  };
  
  type TLayout = {
	children?: React.ReactElement;
	notifySys?: NotifySystem | null;
  };
  
  const Layout = ({ children, notifySys = { container: null, toast: null } }: TLayout) => {
	const { container: ToastContainer = null, toast = null } = notifySys || {};
	const notifyPoints = (points: number) => {
		if(!toast) return;
		toast(
			<span className="cfmui-toast__content">
			  <img className='cfmui-toast__icon' src={thunderIcon} alt="Notificacion" />
			  <span className='cfmui-toast__text'><b>¡Felicidades!</b>, has obtenido <b>+{points} pts</b></span>
			</span>,
			{ className: "cfmui-toast", style: { marginTop: "5rem" } }
		  );
	};

	const {userPoints, getPoints} = usePoints({notifyPoints});

	return (
		<div className="t-layout">
			<UserPointsContext.Provider value={{points: userPoints, getPoints}}>
				<Header />
				<main className="t-layout__content">
					{children || <></>}
				</main>
				<FooterNav />
				<div className="t-layout__footer">
					<Footer />
				</div>
				{ToastContainer && createPortal(<ToastContainer/>, document.body)}
			</UserPointsContext.Provider>
		</div>
	)
}

export default Layout